import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Divider, Grid, Header, Segment, Form } from "semantic-ui-react";
import request from "../../utils/request";
// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.

import EventTicker from "../event/EventTicker";
import GaugeChart from "../common/GaugeChart";
import {
  formatCurrency,
  formatPercent
} from "../../utils/constants";
import GoogleMapMarkerCluster from "../../pages/Map/GoogleMapMarkerCluster";

class CampaignDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      campaign: null,
      showHeatMap: false,
      events: [],
      goals: {},
      stats: {},
      upcoming: []
    };
  }
  componentDidMount = async () => {
    if (this.props.campaignId === null) return;
    const response = await this.getData();
    return response;
  };
  componentDidUpdate = async (prevProps) => {
    if (this.props.campaignId !== prevProps.campaignId) {

      const response = await this.getData();
      return response;
    }
  };

  handleChange = (e, { name, value }) => {
    if (name === 'showHeatMap') {
      value = +!this.state.showHeatMap;
    }
    this.setState({ [name]: value });
  };

  startLoading = () => {
    this.setState({ loading: true });
  };
  doneLoading = () => {
    this.setState({ loading: false });
  };
  getData = async () => {
    const result = await request.list(this, `api:/campaign/${this.props.campaignId}`);
    this.setState(
      {
        campaign: result,
        events: result.events,
        goals: result.goals,
        stats: result.stats,
        upcoming: result.upcoming,
        loading: false,
      }
    );
    return result;
  };

  render() {
    const { columns } = this.props;
    const { campaign, goals, loading, stats, upcoming, showHeatMap } = this.state;
    if (campaign === null) {
      return (
        <div>
          <Header>
            You currently have no active campaigns.
            <Header.Subheader>
              <Link to="/campaigns">
                Create a new campaign or activate an existing one.
              </Link>
            </Header.Subheader>
          </Header>
        </div>
      );
    }

    return (
      <div>
        <Header
          as="h2"
          content={campaign.title}
          subheader={`${campaign.start_at} through ${campaign.end_at}`}
        />
        <Header>Summary</Header>
        <Grid doubling columns={columns || 5}>
          <Grid.Column>
            <Segment loading={loading}>
              <GaugeChart
                label="$ to Date"
                goal={goals.sales || 0}
                value={stats.sales || 0}
                format={formatCurrency}
                delay={200}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment loading={loading}>
              <GaugeChart
                label="% Budget Reached"
                goal={(goals.pct_budget /100) || 0}
                value={stats.pct_budget || 0}
                format={formatPercent}
                delay={400}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment loading={loading}>
              <GaugeChart
                label="Avg. Per Event"
                goal={goals.avg_activation || 0}
                value={stats.avg_activation || 0}
                format={formatCurrency}
                delay={600}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment loading={loading}>
              <GaugeChart
                label="Avg. Per Seller"
                goal={goals.avg_per_seller || 0}
                value={stats.avg_per_seller || 0}
                format={formatCurrency}
                delay={800}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment loading={loading}>
              <GaugeChart
                label="Avg. Web Sale Amount"
                goal={goals.avg_sale_amount || 0}
                value={stats.avg_web_sale_amount || 0}
                format={formatCurrency}
                delay={1000}
              />
            </Segment>
          </Grid.Column>
        </Grid>
        <Divider hidden />
        <Header
          content="Current Events"
          subheader={
            !loading && campaign.events.length === 0 ? "There are no current events" : ""
          }
        />
        {!loading &&
          campaign.events.length > 0 &&
          campaign.events.map(event => (
            <EventTicker
              key={`eventSnapshot${event}`}
              event={event}
              statColumns={6}
            />
          ))}
        <Divider hidden />
        <Header
          content="Upcoming Events"
          subheader={
            !loading && campaign.events.length === 0
              ? "There are no upcoming events"
              : ""
          }
        />
        {!loading &&
          upcoming.length > 0 &&
          upcoming.map(event => (
            <EventTicker
              key={`upcomingSnapshot${event.id}`}
              eventId={event}
              statColumns={6}
            />
          ))}

        <Form.Radio
          toggle
          size="mini"
          label= "Show Sales Map for this Campaign"
          value={showHeatMap}
          name="showHeatMap"
          checked={+showHeatMap === 1}
          onChange={this.handleChange}
          className="radioToggleBtn"
        />
        {showHeatMap === 1 ? <GoogleMapMarkerCluster type='campaign' campaignId = {campaign.id} /> : null}
      </div>
    );
  }
}

export default CampaignDetails;
